import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';
import { OrganizationLevelService } from 'src/app/services/organizationLevel.service';
import { CommonService } from 'src/app/services/common.service';
import { toOrganizationTree } from 'src/app/_helpers/org-tree-helper';
import nameOf from 'src/app/shared/form/nameOf.helper';
import { OrgTreeSelectComponent } from 'src/app/shared/org-tree-select/org-tree-select.component';

interface HasOrgLevelOverride {
  orgLevelOverride: string | null;
}

export const ORG_LEVEL_OVERRIDE_KEY = nameOf<HasOrgLevelOverride>(x => x.orgLevelOverride);

@Component({
    standalone: true,
    selector: 'app-widget-org-filter',
    imports: [OrgTreeSelectComponent],
    templateUrl: './widget-org-filter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./widget-org-filter.component.scss']
})
export class WidgetOrgFilterComponent implements OnInit, OnDestroy {
  @Input() orgLevelId: string | null = null;
  @Input() fullWidth = false;
  @Input() disabled = false;
  @Output() orgLevelIdChange = new EventEmitter<string | null>();

  @HostBinding('class.full-width') get hostFullWidth(): boolean { return this.fullWidth; }

  organizations: OrganizationLevel[] = [];
  topHeaderOrgName = '';
  topHeaderOrgId: string | null = null;

  private destroy$ = new Subject<void>();

  constructor(
    private orgService: OrganizationLevelService,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.orgService.getAll()
      .pipe(takeUntil(this.destroy$))
      .subscribe(orgs => {
        this.organizations = toOrganizationTree(orgs);
      });

    this.commonService.selectedOrgEmitter
      .pipe(takeUntil(this.destroy$))
      .subscribe(org => {
        this.topHeaderOrgName = org?.name ?? '';
        this.topHeaderOrgId = org?.id ?? null;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get displaySelectedId(): string | null {
    return this.orgLevelId ?? this.topHeaderOrgId;
  }

  get isOverridden(): boolean {
    return this.orgLevelId != null;
  }

  onSelectionChange(id: string | null): void {
    if (id != null && id === this.topHeaderOrgId) {
      this.orgLevelIdChange.emit(null);
    } else {
      this.orgLevelIdChange.emit(id);
    }
  }
}
